// @file get current library info
import { DOMContentLoadedPromise } from '@@/bits/dom'
import { ww } from '@@/bits/global'
import { displayNameForUser } from '@@/bits/user_model'
import { LibraryType } from '@@/enums'
import type { Library, LibraryAccess } from '@@/types'

// The Library might not be set on `window` if the scripts have not run.
const getCurrentLibrary = (): Library =>
  ww?.vueStartingState?.library ?? ww?.vueStartingState?.currentLibrary ?? { id: null }

// Initialize with a potentially unsafe value, then update when the DOM is ready.
let currentLibrary = getCurrentLibrary()
export const currentLibraryPromise = DOMContentLoadedPromise.then(getCurrentLibrary)
void currentLibraryPromise.then((library) => (currentLibrary = library))

// Used as a placeholder currentLibrary
const buildSoloLibrary = (user): Partial<Library> => {
  const libraryAccess: LibraryAccess = {
    canViewLibraryInfo: false,
    canUpdateLibraryInfo: false,
    canSetupLti: false,
    canUpdatePermissions: false,
    canViewLibraryMemberships: false,
    canViewLibraryAnalytics: false,
    canManageMembers: false,
    canManageBilling: false,
    canTrashLibrary: false,
    canUseLibraryAsOwner: false,
    canUseLibraryAsAdmin: false,
    canUseLibraryAsTeacher: false,
    canViewLibrarySecurity: false,
    canViewLibraryConnections: false,
    canInviteSchoolAdmins: false,
    canInviteSchoolTeachers: false,
    canInviteSchoolStudents: false,
    canInviteMembers: false,
    canViewGallery: false,
    canManageContentSafetySettings: false,
    canTransferWalls: false,
    canUseAiRecipes: false,
  }

  return {
    name: user != null ? displayNameForUser(user) : 'User',
    avatar: user?.avatar,
    libraryType: LibraryType.Solo,
    libraryAccess,
    slug: user?.username,
  }
}

export default currentLibrary
export { buildSoloLibrary }
